// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a856f829d817630696a81929c38a82ba5ffc177b.chunk.js";
};